import {stateStatusType } from './actionType';

export interface AuthStateProps {
    message: string | null;
    isLoading: boolean;
    error: string | null;
    status: stateStatusType | null;
}

export interface LogoutStateProps {
    logoutState: AuthStateProps;
}

export const initialAuthSate: AuthStateProps = {
    message: null,
    isLoading: false,
    error: null,
    status: null
};

export const initialState: LogoutStateProps = {
    logoutState: initialAuthSate
};
